'use strict';

// Constructor
var BackToTop = function () {
// Add the back to top button
    $('body').append('<button id="return-to-top"><span class="fa fa-chevron-up"></span><span>Top</span></button>');

    // Click show hide and click action
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 100) {        // If page is scrolled more than 100px
            $('#return-to-top').addClass('show');    // Fade in the arrow
        } else {
            $('#return-to-top').removeClass('show');   // Else fade out the arrow
        }
    });
    $('#return-to-top').click(function () {      // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0                       // Scroll to top of body
        }, 1000);
        setTimeout(function() {
            $('.uikit-header__logo-wrapper').focus();
        }, 1000);
    });
    
};

module.exports = BackToTop;